import { ModulePublishingState } from '../../../../../../@types/module-publishing-state';
import api from '../../../../../../api';

export type ModuleContainingUserMaterial = {
  id: string;
  catalogName: string;
  niceName: string;
  publishingState: ModulePublishingState;
  weight: number;
  subjectSlug: string;
  books: {
    id: string;
    niceName: string;
    weight: number;
  }[];
  image?: string;
};

export async function copyMaterial(moduleId: string, nodeId: string, materialIdsToCopy: string[]) {
  return api.post('/studio/user/user-material/copy', {
    materialIds: materialIdsToCopy,
    moduleId,
    nodeId,
  });
}
